import { render } from "./VehicleCategoriesFilterView.vue?vue&type=template&id=0bd3cce2&scoped=true"
import script from "./VehicleCategoriesFilterView.vue?vue&type=script&lang=js"
export * from "./VehicleCategoriesFilterView.vue?vue&type=script&lang=js"

import "./VehicleCategoriesFilterView.vue?vue&type=style&index=0&id=0bd3cce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd3cce2"]])

export default __exports__